































import {
  computed,
  defineComponent,
  PropType,
  ref,
  toRefs
} from '@nuxtjs/composition-api'
import CCountTo from '~/components/shared/configurable/CCountTo.vue'

export default defineComponent({
  components: { CCountTo },
  props: {
    value: { type: Number, default: 0 },
    size: { type: Number, default: 98, required: false },
    variant: {
      type: String as PropType<
        | 'primary'
        | 'secondary'
        | 'info'
        | 'success'
        | 'warning'
        | 'danger'
        | 'white'
        | 'light'
      >,
      default: 'primary'
    },
    customStroke: { type: String, required: false, default: '' },
    customStrokeWidth: { type: Number, default: undefined },
    decimals: { type: Number, required: false, default: 0 }, // if you want decimals set this to 1 or 2
    withoutTransition: { type: Boolean, default: false }
  },
  setup(props) {
    const { size, value, variant, customStroke, customStrokeWidth } = toRefs(
      props
    )

    const triggerAnimation = ref(false)

    const sizePx = computed(() => `${size.value}px`)
    const halfSize = computed(() => `calc(${sizePx.value} / 2)`)
    const strokeWidth = computed(
      () => `${customStrokeWidth.value || size.value / 9.8}px`
    )
    const strokeWidthFg = computed(
      () =>
        `${
          customStrokeWidth.value
            ? customStrokeWidth.value + 1
            : null || size.value / 9.8
        }px`
    )
    const radius = computed(
      () => `calc((${sizePx.value} - ${strokeWidth.value}) / 2)`
    )
    const circumference = computed(() => `calc(${radius.value} * pi * 2)`)
    const dash = computed(
      () =>
        `calc((${triggerAnimation.value ? value.value : 0} * ${
          circumference.value
        }) / 100)`
    )

    const variantStrokeClass = computed(() => {
      if (customStroke.value) {
        return customStroke.value
      }

      switch (variant.value) {
        case 'secondary': {
          return 'tw-stroke-grey-700'
        }
        case 'info': {
          return 'tw-stroke-sky'
        }
        case 'success': {
          return 'tw-stroke-green'
        }
        case 'warning': {
          return 'tw-stroke-yellow'
        }
        case 'danger': {
          return 'tw-stroke-red'
        }
        case 'white': {
          return 'tw-stroke-white'
        }
        case 'light': {
          return 'tw-stroke-grey-400'
        }
        case 'primary':
        default: {
          return 'tw-stroke-primary'
        }
      }
    })

    const circleStyle = computed(() => {
      return {
        cx: halfSize.value,
        cy: halfSize.value,
        r: radius.value,
        strokeWidth: strokeWidth.value
      }
    })

    const fgStyle = computed(() => {
      return {
        ...circleStyle.value,
        strokeWidth: strokeWidthFg.value,
        transformOrigin: `${halfSize.value} ${halfSize.value}`,
        strokeDasharray: `${dash.value} calc(${circumference.value} - ${dash.value})`
      }
    })

    const onVisible = visible => {
      if (visible) {
        triggerAnimation.value = true
      }
    }

    return {
      circleStyle,
      fgStyle,
      triggerAnimation,
      onVisible,
      strokeWidth,
      variantStrokeClass
    }
  }
})
